import { ChannelInstance } from "@features/socket-chats-reworked/types/common";
import { SocketGateType } from "@features/socket-chats-reworked/types/socket";

export const chatTabsTypes = {
  employees: "employees",
  applicant: "applicant",
  technicalSupport: "technicalSupport",
} as const;

export type ChatTabsTypes = (typeof chatTabsTypes)[keyof typeof chatTabsTypes];

export type ChatTabsComponentTypes = {
  mainChatId: string | number;
  technicalSupportChatId?: string | number;
  standalone?: boolean;
  hideLeaveButton?: boolean;
  readonly?: ChannelInstance["readonly"];
  token?: SocketGateType["token"];
  hideTabs?: boolean;
};

export const chatShowOnlyMssages = {
  hidden: "hidden",
  notHidden: "notHidden",
} as const;

export type ChatShowOnlyMssages =
  (typeof chatShowOnlyMssages)[keyof typeof chatShowOnlyMssages];
